import { Attachment } from './attachment.model';

export class DamageContractModel {
  created: Date;
  id: string;
  title: string;
  description: string;
  attachments: Attachment[];
}
